module.exports = __webpack_public_path__ + "img/empty-search.2b6b8438.png";